import { IApplicationState } from '../../types/redux';

export function getNewbuildingClassName(state: IApplicationState) {
  return state.newbuilding.newbuildingClassName;
}
